import { useContext } from 'react';

import type { FeatureFlags } from '@ll-platform/frontend/config/featureFlags/featureFlags';
import { AppFlagsContext } from '@ll-platform/frontend/core/featureFlags/FeatureFlagProvider';

export const useAppFlags = (): FeatureFlags =>
  useContext(AppFlagsContext).flags;
